jQuery(function ($) {
  $('.featured-service').on('mouseenter', function () {
    var targetId = $(this).data('target');

    $('.featured-service').removeClass('active');
    $('.featured-services-image-container').removeClass('active');

    $(this).addClass('active');
    $('#' + targetId).addClass('active');
  });
});
